module.exports = __webpack_public_path__ + "static/media/imac-scrn-ab-wireframes.31199942.jpg";